import { styled } from '@mentimeter/ragnar-styled';
export const FelaButton = styled('button', { displayName: 'Button' })(
  'kosmosSpacing',
  'width',
);
